import type { TomoContent } from '../types/content';
import { TOMO_IMAGES } from './images';

export const tomos: TomoContent[] = [
  {
    number: '01',
    label: 'TOMO 01',
    title: 'DEFENSA Y CONTROL',
    shortDescription: 'Defensa, control y lectura de pared.',
    imageLabel: 'Tomo 1 — Defensa y Control',
    imageUrl: TOMO_IMAGES.tomo1
  },
  {
    number: '02',
    label: 'TOMO 02',
    title: 'ATAQUE Y DEFINICIÓN',
    shortDescription: 'Volea, bandeja, víbora, remate y construcción ofensiva.',
    imageLabel: 'Tomo 2 — Ataque y Definición',
    imageUrl: TOMO_IMAGES.tomo2
  },
  {
    number: '03',
    label: 'TOMO 03',
    title: 'TÁCTICA Y ESTRATEGIA',
    shortDescription: 'Posicionamiento, toma de decisiones y lectura de juego.',
    imageLabel: 'Tomo 3 — Táctica y Estrategia',
    imageUrl: TOMO_IMAGES.tomo3
  },
  {
    number: '04',
    label: 'TOMO 04',
    title: 'METODOLOGÍA Y PLANIFICACIÓN',
    shortDescription: 'Progresiones, organización de sesiones y gestión de grupos.',
    imageLabel: 'Tomo 4 — Metodología y Planificación',
    imageUrl: TOMO_IMAGES.tomo4
  },
  {
    number: '05',
    label: 'TOMO 05',
    title: 'MENTALIDAD, NEGOCIO Y MARCA PERSONAL',
    shortDescription: 'Fidelización, posicionamiento y crecimiento profesional.',
    imageLabel: 'Tomo 5 — Mentalidad, Negocio y Marca Personal',
    imageUrl: TOMO_IMAGES.tomo5
  }
];
